var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 52,
    viewBox: "0 0 68 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 39.9668L49.0683 6.02355C52.3877 2.70409 57.7696 2.7041 61.0891 6.02355C64.4085 9.34301 64.4085 14.7249 61.0891 18.0444L27.1458 51.9876L15.125 39.9668Z",
    fill: "#91CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1309 51.9883L6.90277 31.7033C3.58798 28.3792 3.59554 22.9973 6.91965 19.6825C10.2438 16.3677 15.6257 16.3753 18.9405 19.6994L39.1685 39.9844L27.1309 51.9883Z",
    fill: "#2E3E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.688012eece65d66800867f0ce6af29e1.svg";
export { ForwardRef as ReactComponent };